module.exports = __webpack_public_path__ + "static/media/wrong_ans.eb538615.png";